import { yup } from '@guiker/yup-util'

export const bookingIdNested = yup.object({
  bookingId: yup.string().required(),
})
